import {dom} from "@e280/sly"
import {landingPage} from "./website/index.js"

console.log("🌀 Omniclip")

dom.register({landingPage})
